import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'nr-translator-watermark',
  imports: [],
  templateUrl: './translator-watermark.html',
  styleUrl: './translator-watermark.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslatorWatermarkComponent {}
